export default __webpack_public_path__ + "static/media/select-arrow.69b9f19d.svg";